import { EnvelopeSimple, Envelope, Phone, Users, NotePencil, ArrowUpRight, ArrowDownLeft, Circle } from "@phosphor-icons/react";

export const KIND = {
  letter: { label: "Brief", icon: Envelope },
  email: { label: "E-Mail", icon: EnvelopeSimple },
  call: { label: "Telefonat", icon: Phone },
  meeting: { label: "Gespräch", icon: Users },
  note: { label: "Notiz", icon: NotePencil },
};
export const DIRECTION = {
  out: { label: "Ausgang", icon: ArrowUpRight, cls: "text-sky-700 bg-sky-50 border-sky-200" },
  in: { label: "Eingang", icon: ArrowDownLeft, cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  internal: { label: "Intern", icon: Circle, cls: "text-slate-600 bg-slate-50 border-slate-200" },
};
export const TONE = {
  ok: "text-emerald-700 bg-emerald-50 border-emerald-200",
  warn: "text-amber-800 bg-amber-50 border-amber-200",
  error: "text-red-700 bg-red-50 border-red-200",
  neutral: "text-slate-600 bg-slate-50 border-slate-200",
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const counterpart = (e) => {
  if (e.direction === "in") return e.sender?.name || e.sender?.email || "Unbekannt";
  return (e.recipients || []).map((r) => r.name).filter(Boolean).join(", ") || "—";
};

export function Pill({ cls, children, testId }) {
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium ${cls}`} data-testid={testId}>{children}</span>;
}
